<!-- VisibilityMonitor.vue -->
<script setup lang="ts">
    import { onMounted, onUnmounted } from 'vue';

    onMounted(() =>{
        addEventListener("visibilitychange", fireEvent);
    });
    onUnmounted(() =>{
        removeEventListener("visibilitychange", fireEvent);
    })

    const emit = defineEmits<{
        visibile: [isVisible: boolean]
    }>();

    function fireEvent()
    {
        emit("visibile", "visible" === document.visibilityState);
    }
</script>